<template>
    <svg height="96" viewBox="0 0 96 96" width="96" xmlns="http://www.w3.org/2000/svg">
        <!-- @vue-ignore -->
        <g fill="none" fill-rule="evenodd">
            <!-- @vue-ignore -->
            <circle cx="48" cy="48" r="39" stroke="currentColor" stroke-width="2" />
            <!-- @vue-ignore -->
            <path
                d="m53.6 60.3087823v2.9980669c0 .125932-.1001394.2270091-.2207374.2270091h-10.7278373c-.1222132 0-.2207374-.1016294-.2207374-.2270091v-2.9980669c0-.1253797.0990626-.2270091.2207374-.2270091h3.0903235v-15.9790113h-3.1220882c-.1222131 0-.2196606-.1016294-.2196606-.2259045v-3.0660038c0-.1259321.0979859-.2264568.2196606-.2264568h7.3198674c.1222131 0 .2207373.101077.2207373.2264568v19.2709196h3.2189973c.120598 0 .2207374.1016294.2207374.2270091zm-9.7495938-25.322839c0-1.9066556 1.5058597-3.452085 3.3648993-3.452085 1.8579628 0 3.3648993 1.5454294 3.3648993 3.452085s-1.5069365 3.4520851-3.3648993 3.4520851c-1.859578 0-3.3648993-1.5454295-3.3648993-3.4520851z"
                fill="currentColor"
                fill-rule="nonzero"
            />
        </g>
    </svg>
</template>
